import { useQuery } from '@tanstack/react-query';

import { QueryKeys } from '../../query.client';
import billingService from '../../services/billing/billing.service';

export default function useTrialDataQuery(isVerifiedUser?: boolean, teamId?: string) {
  const { data, error, isLoading, isFetching, refetch } = useQuery({
    enabled: !!(isVerifiedUser && teamId),
    queryKey: [QueryKeys.TRIAL_DATA],
    queryFn: async () => {
      return billingService.getTrialData();
    },
    cacheTime: 10000,
  });

  return {
    trialData: data,
    trialDataError: error,
    isLoadingTrialData: isLoading,
    isFetchingTrialData: isFetching,
    refetchTrialData: refetch,
  };
}
